import directives from './module';
import {Utils} from 'underscore-extensions';

directives.directive('documentNoScroll', () =>
        (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: any) => {
            const documentEl = document.documentElement,
                className = 'noscroll';

            const disableScroll = () => {
                const scrollTop = window.scrollY || window.pageYOffset;
                documentEl.classList.add(className);
                document.body.style.top = `-${scrollTop}px`;
            };

            const enableScroll = () => {
                const scrollTop = document.body.style.top ? parseInt(document.body.style.top, 10) : 0;
                document.body.style.top = '';
                documentEl.classList.remove(className);
                window.scrollTo(0, Math.abs(scrollTop));
            };

            scope.$watch(attrs.documentNoScroll, (newVal, oldVal) => Utils.rAF(() => {
                if (newVal) {
                    disableScroll();
                } else if (!newVal && oldVal) {
                    enableScroll();
                }
            }));

            scope.$on('$destroy', enableScroll);
        }
);



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/documentNoScroll.ts